import { render, staticRenderFns } from "./SelectSprachkenntnisse.vue?vue&type=template&id=fca2775a"
import script from "./SelectSprachkenntnisse.vue?vue&type=script&lang=js"
export * from "./SelectSprachkenntnisse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports